const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export async function applyMetaTags(fallbackTitle = "Empire Estates", fallbackDesc = "") {
  let metaTitle = fallbackTitle;
  let metaDescription = fallbackDesc;
  let metaKeywords = '';

  try {
    const res = await fetch(`${API_BASE}/meta`);
    if (res.ok) {
      const list = await res.json();

      // Normalize current pathname: strip '/react' prefix and trailing slash
      const currentPath = window.location.pathname
        .toLowerCase()
        .replace(/^\/react/, '')
        .replace(/\/$/, '') || '/';
      const routeSegments = currentPath.split('/').filter(Boolean);

      const match = list.find(m => {
        let storedPath = m.pageUrl || '';
        if (storedPath.startsWith('http')) {
          try {
            storedPath = new URL(storedPath).pathname;
          } catch (e) {}
        }
        const stored = storedPath
          .toLowerCase()
          .replace(/^\/react/, '')
          .replace(/\/$/, '') || '/';
        if (stored === currentPath) return true;
        const storedSegments = stored.split('/').filter(Boolean);
        return storedSegments.length > 0 && storedSegments.length <= routeSegments.length &&
          storedSegments.every((segment, index) => segment === routeSegments[index]) &&
          storedSegments.length === routeSegments.length;
      });

      if (match) {
        metaTitle = match.metaTitle || fallbackTitle;
        metaDescription = match.metaDescription || fallbackDesc;
        metaKeywords = match.metaKeywords || '';
      }
    }
  } catch (err) {
    console.warn('Could not load meta tags, using defaults:', err.message);
  }

  document.title = metaTitle;

  let metaDescTag = document.querySelector('meta[name="description"]');
  if (!metaDescTag) {
    metaDescTag = document.createElement('meta');
    metaDescTag.setAttribute('name', 'description');
    document.head.appendChild(metaDescTag);
  }
  metaDescTag.setAttribute('content', metaDescription);

  const siteOrigin = 'https://empireesttates.in';
  const canonicalUrl = `${siteOrigin}${window.location.pathname}`;
  const setMeta = (selector, attributes, content) => {
    let tag = document.head.querySelector(selector);
    if (!tag) {
      tag = document.createElement('meta');
      Object.entries(attributes).forEach(([key, value]) => tag.setAttribute(key, value));
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  };
  const setLink = (rel, href) => {
    let tag = document.head.querySelector(`link[rel="${rel}"]`);
    if (!tag) {
      tag = document.createElement('link');
      tag.setAttribute('rel', rel);
      document.head.appendChild(tag);
    }
    tag.setAttribute('href', href);
  };

  setLink('canonical', canonicalUrl);
  setMeta('meta[property="og:title"]', { property: 'og:title' }, metaTitle);
  setMeta('meta[property="og:description"]', { property: 'og:description' }, metaDescription);
  setMeta('meta[property="og:url"]', { property: 'og:url' }, canonicalUrl);
  setMeta('meta[property="og:image"]', { property: 'og:image' }, `${siteOrigin}/favicons.png`);
  setMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, metaTitle);
  setMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, metaDescription);
  setMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, `${siteOrigin}/favicons.png`);

  if (metaKeywords) {
    let metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    if (!metaKeywordsTag) {
      metaKeywordsTag = document.createElement('meta');
      metaKeywordsTag.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywordsTag);
    }
    metaKeywordsTag.setAttribute('content', metaKeywords);
  } else {
    let metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    if (metaKeywordsTag) {
      metaKeywordsTag.remove();
    }
  }
}
